(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["probier-digital-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-results-preview')) {
    customElements.define('pb-results-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const choices = [...this.querySelectorAll('[data-pb-demo-choice]')];
        const panels = [...this.querySelectorAll('[data-pb-demo-panel]')];
        if (choices.length < 2) return;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let index = Math.max(0, choices.findIndex((choice) => choice.getAttribute('aria-pressed') === 'true'));
        let paused = motion.matches;
        let focused = false;
        let visible = false;
        let timer;
        const select = (next) => {
          index = next;
          const selected = choices[index].dataset.pbDemoChoice;
          choices.forEach((choice) => choice.setAttribute('aria-pressed', String(choice.dataset.pbDemoChoice === selected)));
          panels.forEach((panel) => { panel.hidden = panel.dataset.pbDemoPanel !== selected; });
        };
        const schedule = () => {
          window.clearInterval(timer);
          const playing = !paused && !focused && visible && !document.hidden;
          this.dataset.pbAutoplay = playing ? 'playing' : 'paused';
          if (playing) timer = window.setInterval(() => select((index + 1) % choices.length), 6500);
        };
        const onClick = (event) => {
          if (!(event.target instanceof Element)) return;
          const choice = event.target.closest('[data-pb-demo-choice]');
          if (choices.includes(choice)) {
            select(choices.indexOf(choice));
            schedule();
          }
        };
        const onPointer = () => { focused = false; schedule(); };
        const onFocus = (event) => { focused = event.target.matches(':focus-visible'); schedule(); };
        const onBlur = (event) => {
          focused = event.relatedTarget instanceof Element && this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible');
          schedule();
        };
        const onKey = () => { focused = true; schedule(); };
        const onMotion = () => { paused = motion.matches; schedule(); };
        const observer = new IntersectionObserver((entries) => {
          visible = entries.some((entry) => entry.isIntersecting);
          if (visible) this.querySelectorAll('img').forEach((img) => { img.loading = 'eager'; });
          schedule();
        }, { threshold: 0.2 });
        observer.observe(this);
        this.addEventListener('click', onClick);
        this.addEventListener('pointerdown', onPointer);
        this.addEventListener('keydown', onKey);
        this.addEventListener('focusin', onFocus);
        this.addEventListener('focusout', onBlur);
        document.addEventListener('visibilitychange', schedule);
        motion.addEventListener('change', onMotion);
        schedule();
        this.cleanup = () => {
          window.clearInterval(timer);
          observer.disconnect();
          this.removeEventListener('click', onClick);
          this.removeEventListener('pointerdown', onPointer);
          this.removeEventListener('keydown', onKey);
          this.removeEventListener('focusin', onFocus);
          this.removeEventListener('focusout', onBlur);
          document.removeEventListener('visibilitychange', schedule);
          motion.removeEventListener('change', onMotion);
        };
      }
      disconnectedCallback() {
        if (this.cleanup) this.cleanup();
        this.cleanup = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
